import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import Box from "../../components/Box";
import Button from "../../components/Button";
import Reservation from "../../components/EntryAccess/Reservation";
import DisputeNumber from "../../components/EntryAccess/DisputeNumber";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import Textfield from "../../components/Textfield";
import { ToastMessage } from "../../components/ToastMessage";
import Toggle from "../../components/Toggle";
import { Colors } from "../../config/Constants";
import { useLoadContext } from "../../contexts/LoadContext";
import {
  putEntryAccessUpdate,
  getSettingsEntryAccess,
} from "../../services/settingsService";
import { entryAccessValidation } from "./validation";

type postDataType = {
  name: string;
  [any: string]: any;
  isActive: boolean;
};

const EntryAccess = () => {
  const [fee, setFee] = useState(""); // eslint-disable-line
  const [topup, setTopup] = useState("");
  const [feeToggle, setFeeToggle] = useState(false); // eslint-disable-line
  const [topupToggle, setTopupToggle] = useState(false);
  // const [feeError, setFeeError] = useState("");
  const [topupError, setTopupError] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFailure, setIsFailure] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    header: "",
    subHeader: "",
  });
  const { setLoader } = useLoadContext();
  let data: postDataType = {
    name: "",
    amount: 0,
    isActive: false,
  };
  const [disputeNumber, setDisputeNumber] = useState("");
  const [reservationAmount, setReservationAmount] = useState("");
  const [reservationToggle, setReservationToggle] = useState(false);

  // const handleParkingSave = () => {
  //   let isValid = entryAccessValidation(fee, setFeeError);
  //   if (isValid) {
  //     updateDataValues("parking", fee, feeToggle);
  //     console.log(data);
  //     postChangedData("parking", data);
  //   }
  // };
  // const handleParkingEdit = () => {
  //   setFeeToggle(!feeToggle);
  // };
  const handleTopupSave = () => {
    let isValid = entryAccessValidation(topup, setTopupError);
    if (isValid) {
      updateDataValues("top up", topup, topupToggle);
      postChangedData("topup", data);
    }
  };
  const handleTopupEdit = () => {
    setTopupToggle(!topupToggle);
  };

  const updateDataValues = (
    dataName: string,
    dataAmount: string,
    isDataActive: boolean
  ) => {
    data.name = dataName;
    data.amount = Number(dataAmount);
    data.isActive = isDataActive;
  };

  useEffect(() => {
    getApiData();
  }, []); // eslint-disable-line

  const getApiData = async () => {
    setLoader(true);
    try {
      const response = await getSettingsEntryAccess();
      if (response.status === 200) {
        response.data.data.forEach((eachItem: any) => {
          if (eachItem.type === "parking") {
            setFee(eachItem.amount);
            setFeeToggle(eachItem.isActive);
          } else if (eachItem.type === "topup") {
            setTopup(eachItem.amount);
            setTopupToggle(eachItem.isActive);
          } else if (eachItem.type === "disputenotify") {
            setDisputeNumber(eachItem.phone);
          } else if (eachItem.type === "reservationfee") {
            setReservationAmount(eachItem.amount);
            setReservationToggle(eachItem.isActive);
          }
        });
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setErrorMessage({
          header: "Something went wrong",
          subHeader: error.message,
        });
        setIsFailure(true);
      }
    }
    setLoader(false);
  };
  const postChangedData = async (
    entryAccessType: "parking" | "topup" | "disputenotify" | "reservationfee",
    data: postDataType
  ) => {
    setLoader(true);
    try {
      const response = await putEntryAccessUpdate(entryAccessType, data);
      if (response.status === 200) {
        setIsSuccess(true);
      }
    } catch (error: any) {
      if (navigator.onLine) {
        setErrorMessage({
          header: "The Changes could not be saved!",
          subHeader: error.message,
        });
        setIsFailure(true);
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoader(false);
  };
  return (
    <>
      <Header>Settings</Header>
      <Box>
        <Container>
          {/* <RowWrapper>
            <TextWrapper>
              <Textfield
                value={fee}
                placeholder={fee}
                label="Parking Fee"
                variant="outlined"
                size="medium"
                onChange={(e) => {
                  setFee(e.target.value);
                  setFeeError("");
                }}
                disabled={!feeToggle}
                textColor={Colors.black}
                error={feeError ? true : false}
              />
              {feeError && <ErrorMessage>{feeError}</ErrorMessage>}
            </TextWrapper>
            <ActionWrapper>
              <ToggleWrapper>
                <Toggle
                  uniqueName="parking"
                  isChecked={feeToggle}
                  onChange={handleParkingEdit}
                />
              </ToggleWrapper>
              <div className="actionWrapper">
                <Button
                  variant="filled"
                  label="Save"
                  onClick={handleParkingSave}
                  color={Colors.red}
                />
              </div>
            </ActionWrapper>
          </RowWrapper> */}

          <RowWrapper>
            <TextWrapper>
              <Textfield
                value={topup}
                placeholder={topup}
                disabled={!topupToggle}
                textColor={Colors.black}
                label="Entry Fee"
                variant="outlined"
                size="medium"
                onChange={(e) => {
                  setTopup(e.target.value);
                  setTopupError("");
                }}
                error={topupError ? true : false}
              />
              {topupError && <ErrorMessage>{topupError}</ErrorMessage>}
            </TextWrapper>
            <ActionWrapper>
              <ToggleWrapper>
                <Toggle
                  uniqueName="topup"
                  isChecked={topupToggle}
                  onChange={handleTopupEdit}
                />
              </ToggleWrapper>
              <div className="actionWrapper">
                <Button
                  variant="filled"
                  label="Save"
                  onClick={handleTopupSave}
                  color={Colors.red}
                />
              </div>
            </ActionWrapper>
          </RowWrapper>
        </Container>
      </Box>
      <DisputeNumber
        postChangedData={postChangedData}
        disputeNumber={disputeNumber}
        setDisputeNumber={setDisputeNumber}
      />
      <Reservation
        postChangedData={postChangedData}
        setReservationAmount={setReservationAmount}
        reservationAmount={reservationAmount}
        reservationToggle={reservationToggle}
        setReservationToggle={setReservationToggle}
      />
      {isSuccess && (
        <ErrorSuccessModal
          variant="success"
          heading="Saved successfully!"
          buttonLabel="Ok"
          setOpenOrClose={setIsSuccess}
          onSubmit={() => setIsSuccess(false)}
        />
      )}
      {isFailure && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.header}
          subHeading={errorMessage.subHeader}
          buttonLabel="Ok"
          setOpenOrClose={setIsFailure}
          onSubmit={() => {
            setIsFailure(false);
            setErrorMessage({
              header: "",
              subHeader: "",
            });
          }}
        />
      )}
    </>
  );
};

export default EntryAccess;

export const Container = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  padding-bottom: 3.5rem;
  @media only screen and (max-width: 768px) {
    gap: 5rem;
  }
`;
export const RowWrapper = styled.div`
  display: flex;
  gap: 3rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;
export const TextWrapper = styled.div`
  flex: 1;
`;
export const ActionWrapper = styled.div`
  flex: 1;
  display: flex;
  gap: 3rem;
  align-items: flex-end;
  > .actionWrapper {
    width: 9.3rem;
  }
  > .disputeWrapper {
    width: 9.3rem;
    margin-left: 5.5rem;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    > .actionWrapper {
      width: 100%;
    }
    > .disputeWrapper {
      width: 100%;
    }
  }
`;
export const ToggleWrapper = styled.div`
  padding-bottom: 0.5rem;
`;
export const Header = styled.div`
  font-size: 1.25rem;
  padding-bottom: 2rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
  margin-top: 2rem;
`;
export const ErrorMessage = styled.div`
  font-family: "Poppins-Book";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  margin-top: 0.25rem;
`;
